import { FC } from 'react';
import { useGetCriteria } from 'hooks/api/criteria';

interface CriteriaBreadcrumbsProps {
  match?: any;
}

const CriteriaBreadcrumbs: FC<CriteriaBreadcrumbsProps> = ({ match }) => {
  const { criteriaId } = match?.params ?? '';

  const {data: criteriaData} = useGetCriteria(criteriaId);

  return <>{criteriaData?.data.name}</>;
};

export default CriteriaBreadcrumbs;
